import store from '../../store';
import { IData } from './types/responses';

const getPronoun = (gender: string) => {
  if (gender === 'Male') {
    return 'He';
  }

  return 'She';
};

const getOfferAction = (accountType: string) => {
  if (accountType === 'Generous') {
    return 'Send a message';
  }

  return 'Unlock the conversation';
};

// default notification details
let notifDetails: any = {
  label: 'You have new notifications!',
  action: 'Check them out',
  color: 'red',
  hasFavIcon: false,
  link: '',
  giftData: {},
};

const getNotifLink = (data: IData, isMail = false, isFav = false) => {
  switch (true) {
    case isMail:
      return `/mail/${data?.thread?.uid ?? data?.extras?.thread_uid ?? data.account.hash_id}`;
    case isFav:
      return '/interests/favorited-me';
    default:
      return `/profile/${data.account.hash_id}?notif_ref=true`;
  }
};

const getConversationLink = (data: IData) => {
  return `/mail/${data?.extras?.thread_uid ?? data.account.hash_id}`;
};

const getOfferNotification = (action: string, data: IData) => {
  const { alert_offer } = store.getState().settings;
  const profileData = store.getState()?.profile?.profile?.data;
  const isGenerous = profileData?.account_type === 'Generous';

  if (!alert_offer) return;

  switch (action) {
    case 'receive':
      notifDetails = {
        ...notifDetails,
        label: `${data.account.username} sent you ${isGenerous ? 'a Request' : 'an Offer'}!`,
        action: `Review ${isGenerous ? 'Request' : 'Offer'}!`,
        link: getNotifLink(data),
        hasFavIcon: false,
        color: 'gold',
      };
      return notifDetails;
    case 'suggest':
      notifDetails = {
        ...notifDetails,
        label: `${getPronoun(data.profile.gender)}'s interested!`,
        action: 'Check them out',
        link: getNotifLink(data),
        hasFavIcon: false,
        color: 'gold',
      };
      return notifDetails;
    case 'accept':
      notifDetails = {
        ...notifDetails,
        label: `${isGenerous ? 'Offer' : 'Request'} Accepted`,
        action: getOfferAction(data.profile.account_type),
        link: getNotifLink(data, true),
        hasFavIcon: false,
      };
      return notifDetails;
    case 'update':
      notifDetails = {
        ...notifDetails,
        label: `Great news! ${data.account.username} raised their ${isGenerous ? 'request' : 'offer'}!`,
        action: `Review ${isGenerous ? 'Request' : 'Offer'}!`,
        link: getNotifLink(data),
        hasFavIcon: false,
        color: 'gold',
      };
      return notifDetails;
  }
};

const getMailNotification = (action: string, data: IData) => {
  const { alert_mail } = store.getState().settings;

  if (!alert_mail) return;

  switch (action) {
    case 'receive':
      return {
        label: `${data.account.username} has sent you a new message`,
        action: 'Your turn',
        link: getNotifLink(data, true),
        color: 'red',
        hasFavIcon: false,
      };
    case 'unlock':
      return {
        label: `${data.account.username} has unlocked your conversation!`,
        action: 'Send a message',
        link: getNotifLink(data, true),
        color: 'red',
        hasFavIcon: false,
      };
    default:
      return;
  }
};

const getFavoritedNotification = (data: IData) => {
  const { alert_favorite } = store.getState().settings;

  if (!alert_favorite) return;

  notifDetails = {
    ...notifDetails,
    label: ` You've been favorited!`,
    action: ' Check them out',
    link: getNotifLink(data, false, true),
    hasFavIcon: true,
    color: 'red',
  };
  return notifDetails;
};

const getPokeNotification = (data: IData) => {
  notifDetails = {
    ...notifDetails,
    label: `${getPronoun(data.profile.gender)} sent a reminder!`,
    action: 'Unlock the conversation',
    link: getNotifLink(data),
  };
  return notifDetails;
};

const getVideoCallNotification = (action: string, data: IData) => {
  notifDetails = {
    label: `is calling you for a video chat`,
    action,
    link: getConversationLink(data),
    videoData: {
      ...data.extras,
      signal: data.extras.signal || null,
    },
    profilePhoto: data.profile.photo,
    callerName: data.account.username,
  };
  return notifDetails;
};

export const getResponse = (type: string, action: string, data: IData): any => {
  const defaultNotifDetails = {
    ...notifDetails,
    label: `You've got a new ${type}!`,
    link: getNotifLink(data),
  };

  switch (type) {
    case 'video_call':
      return getVideoCallNotification(action, data);
    case 'favorites':
      return getFavoritedNotification(data);
    case 'offers':
      return getOfferNotification(action, data);
    case 'mail':
      return getMailNotification(action, data);
    case 'poke':
      return getPokeNotification(data);
    case 'viewed_me':
      return;
    default:
      return defaultNotifDetails;
  }
};
